<template>
	<popup-backdrop @close="closePopup()">
    <side-popup title="Integration settings" :loading="loading" :level="0" @close="closePopup">

        <template v-slot:default>
            <content-header
                :active="isActive"
                :attributes="attributes"
                :panel="isPanel"
                @toggleActive="toggleActive"
                @togglePanel="togglePanel" />

	        <shopify-settings v-if="isShopify" :config="config" :attributes="attributes"
	                          :config-data="configData" :is-shopify-redirect="isShopifyRedirect"
	                          :redirect-shop-name="redirectShopName" @reload="init()" />

          <div v-else class="work-area">
            <!-- zapier integration -->
            <div v-if="id==13">
	            <zapier-props />
            </div>
            <div v-else-if="isConnect" class="brdr_box_w_checkbox layout-column">
              <connect-service :attributes="attributes" :config="configData" >
                    <template v-slot:connect>
                      <div v-if="attributes.name==='google_sheets'" :class="{'disabled':connecting}"
                           class="google-connect-btn" @click.prevent="connectToService(id)">
                      </div>
                      <v-button v-else label="Connect" :loading="connecting" @click.prevent="connectToService(id)" />
                    </template>
                    <template v-slot:disconnect>
                        <v-button label="Disconnect" :loading="connecting" @click.prevent="disconnectFromService(id)" />
                    </template>
                </connect-service>
            </div>

            <div v-else class="brdr_box_w_checkbox" v-for="(item, index) in configSchema">
              <template  v-if="item.type === 'select'">
                <div class="right w100">
	                <h3>{{item.caption}}</h3>
	                <v-select v-model="config[item.name]" :options="item.options" />
                </div>
              </template>
              <input-field v-else class="right w100 form-group with-copy-icon mb-0 with_top_block"
                    :label="item.caption" v-model="config[item.name]" />
            </div>
          </div>
        </template>

        <template v-slot:actions>
	        <v-button @click="saveIntegration" :loading="saving" label="Save changes"></v-button>
          <v-button border @click="closePopup" label="Cancel" />
        </template>

    </side-popup>
	</popup-backdrop>
</template>

<script>
import API from "@/api"
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import DetailsPopup from "@/components/base/details-popup";
import detailsParts from "@/components/popup-details-parts/"
import ConnectService from "@/components/popup-details-parts/connect-service";
import ZapierProps from "@/components/integrations/zapier-props";
import VSwitch from "@/components/base/v-switch";
import ShopifySettings from "@/views/integrations/shopify-settings";
import ContentHeader from "@/components/popup-details-parts/content-header";
import SidePopup from "@/components/base/side-popup";
import PopupBackdrop from "@/components/base/popup-backdrop";

export default {
	name: "IntegrationsDetails",
	title: "Integration Details | Funnelish™",
	components: {
		PopupBackdrop,
		SidePopup,
		ContentHeader, ShopifySettings, VSwitch, ZapierProps, ConnectService, InputField, VButton, DetailsPopup, ...detailsParts},
	mixins: [API],
	data() {
		return {
			connecting: false,
			saving: false,
			loading: true,
			showRightPanel: false,
			thisIntegration: {
				user_integration: {}
			},
			isShopifyRedirect: false, redirectShopName: '',
		}
	},
	computed: {
		config() {
			if (!this.thisIntegration || !this.thisIntegration.user_integration)
				return {};
			let atts = this.thisIntegration.user_integration;
			if (!atts) return {};
			return atts.config || {};
		},
		attributes() {
			return this.thisIntegration;
		},
		isActive() {
			return this.thisIntegration.user_integration.active;
		},
		isPanel() {
			return this.showRightPanel;
		},
		configSchema() {
			return this.thisIntegration.config;
		},
		configData() {
			return this.thisIntegration.user_integration.config;
		},
		id() {
			return this.thisIntegration.id || this.$route.params.id;
		},
		isConnect() {
			return this.id === 5 || this.id === 6;
		},
		isShopify() {
			return this.id === 5;
		}
	},
	methods: {
		toggleActive() {
			this.thisIntegration.user_integration.active = !this.thisIntegration.user_integration.active;
		},
		togglePanel() {
			this.showRightPanel = !this.showRightPanel;
		},
		closePopup() {
			this.$router.push({path: '/integrations'});
		},
		storeNameChanged(v) {
			v = v.replace("https://", "").replace("/", "")
			this.thisIntegration.user_integration.config.store_url = v;
		},
		async connectToService() {
			try {
				this.connecting = true;

				// https://app.funnelish.com/api/v1/integration-handlers/shopify-install
				if (this.isShopifyRedirect) {
					let host = window.location.host;
					if (host.includes("localhost") || host.includes("beta.funnelish.com")) {
						if (host.includes("localhost")) host = 'localhost:8000';

						let installUrl = `${window.location.protocol}//${host}/api/v1/integration-handlers/shopify-connect`

						delete this.$route.query['integration-redirect'];
						let query = JSON.parse(JSON.stringify(this.$route.query))
						query['token'] = this.$store.state.token;

						window.location = installUrl + '?' + Object.keys(query)
								.map(key => {
									return (encodeURIComponent(key) + '=' + encodeURIComponent(query[key]))
								})
								.join('&');
						return
					}
				}

				let result = await this.api.integrations.connect(this.attributes.name,
						{arg1: this.config.store_url})
				if (result.success) window.location.replace(result.result);
			} catch (e) {
				this.connecting = false;
				this.$error(e)
			} finally {
			}
		}, async disconnectFromService(id) {
			try {
				this.connecting = true;
				let result = await this.api.integrations.disconnect(this.attributes.name, {
					arg1: '', arg2: "", id: 0
				});
				if (result.success) {
					await this.init();
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.connecting = false;
			}
		},

		async saveIntegration() {
			try {
				this.saving = true;
				let savedIntegration = JSON.parse(JSON.stringify(this.thisIntegration));

				savedIntegration.user_integration.config = JSON.stringify(savedIntegration.user_integration.config);
				savedIntegration.config = JSON.stringify(savedIntegration.config)

				var result = await this.api.integrations.updateUserIntegration(this.id, savedIntegration.user_integration);
				this.$emit('updated', savedIntegration.user_integration);
				this.closePopup();
			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		},
		async init() {
			this.thisIntegration = await this.api.integrations.get(this.id);

			this.thisIntegration.user_integration.config = JSON.parse(this.thisIntegration.user_integration.config);
			this.thisIntegration.config = JSON.parse(this.thisIntegration.config);

			this.$nextTick(() => {
				if (this.isShopifyRedirect && this.redirectShopName) {
					if (this.config.store_url !== this.redirectShopName || !this.config.token) {
						this.config.store_url = this.redirectShopName;

						// Clear query (to prevent double connecting)
						this.connectToService();
					}
					this.$router.replace({path: this.$route.path})
					return
				}
				this.loading = false;
			});
		},
	},
	created() {
		if (window.opener) {
			// If the window was opened by code, mostly was opened by an integration auto-connect popuup...
			// Check if parent is waiting for us (same integration) to close, and close.
			try {
				if (window.opener.window.waitingForIntegration == this.$route.params.id) {
					window.opener.window.waitingForIntegration = null;
					window.close();
				}
			} catch (e) { // sometimes would crash if remote opener is different host.
				console.error("error", e);
			}
		}
		this.init();
	},
	mounted() {
		if (this.$route.query['integration-redirect'] === '5') {
			// redirect from Shopify app install
			this.isShopifyRedirect = true;
			this.redirectShopName = this.$route.query.shop || '';
			if (this.config.store_url !== this.redirectShopName || !this.config.token) {
				this.connecting = true;
			}
		}
	}
}
</script>
<style>
.right-side-html {
    position: relative;
    overflow: auto;
    height: 100%;
    padding: 15px 15px;
}
.helpbox {
    background: #f6f9fe;
    border-radius: 8px;
    padding: 15px;
}
.form-group.mb-0 {
    margin-bottom: 0;
}
.right.w100 {
    width: 100%;
}
.info_btn {
    position: relative;
}
.info_btn .tooltip {
    position: absolute;
    width: 360px;
    background-color: #fff;
    padding: 5px;
    text-align: center;
    font-size: 12px;
    border: 1px solid #E4E6F1;
    border-radius: 3px;
    color: #636a7b;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
    bottom: calc(100% + 10px);
    right: 0;
    left: auto;
    transform: none;
}
.info_btn:hover .tooltip {
    opacity: 1;
    visibility: visible;
}
.app_settings_popup .popup_right_side .right-side-html p {
    margin-top: 0;
    margin-bottom: 15px;
}
.app_settings_popup .popup_right_side .right-side-html p + p {
    background: #EBEFF6!important;
    border-radius: 4px!important;
    border: none!important;
    padding: 3px 7px!important;
}
.right-side-html iframe {
    width: 100%;
    height: 200px;
    border: 5px solid #EBEFF6;
    border-radius: 12px;
    overflow: hidden;
}
.right-side-html img {
    display: block;
    max-width: 100%;
    height: auto;
}
.right-side-html a {
    color: #4368e0;
}
.right-side-html h5 {
    margin-top: 40px;
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.02em;
    color: #252A32;
}
.right-side-html ul li {
    padding-left: 18px;
    position: relative;
    margin-bottom: 15px;
}
.right-side-html ul li:before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    left: 0px;
    top: 4px;
    background: #D5E5FF;
    border-radius: 100%;
}
.right-side-html ol {
   padding-left: 18px;
}
.right-side-html ol li {
    margin-bottom: 15px;
}
.right-check-inner {
    display: flex;
    margin-top: 15px;
}
.brdr_box_w_checkbox:empty {
    display: none;
}
/* .funnel-app-settings {
    overflow: visible
} */
</style>
